@if(externalLink){
<!---Download need the href maybe other sec-->
@if (variantLink === 'link' ) {

<a class="hyperlink" [href]="link" target="_blank" rel="noopener noreferrer" (keyup)="onKeyUpLink($event)">
  {{ text }}
</a>

} }

<!-- When Is internal Link-->
@if(!externalLink){ @if (variantLink === 'link' ) {

<a class="hyperlink" [routerLink]="link" [attr.aria-label]="ariaLabel" (keyup)="onKeyUpLink($event)">
  {{ text }}
</a>

} }

<!-- Download-->
@if(variantLink === 'download') {
<a class="hyperlink" [href]="link" (keyup)="onKeyUpDownload($event)" (click)="downloadClickEvent($event)">
  {{ text }}
</a>
}